const itSupportServicesData = [
  {
    title: "Helpdesk",
    description:
      "Responsive L1/L2 helpdesk with defined SLAs, knowledge base, escalation paths, and regular reporting.",
    bullets: ["Ticketing", "SLA", "Knowledge Base", "Reports"],
    minHeight: 400,
  },
  {
    title: "Endpoint Management",
    description:
      "Centralized endpoint management for OS updates, hardening, patching, and asset inventory across devices.",
    bullets: ["MDM", "Patching", "Asset", "Security"],
    minHeight: 400,
  },
  {
    title: "Networking",
    description:
      "Design and operate wired/wireless networks with resilient VPN, firewall policies, and proactive monitoring.",
    bullets: ["LAN/WiFi", "VPN", "Firewall", "Monitoring"],
    minHeight: 400,
  },
  {
    title: "Directory & Access",
    description:
      "Identity and access management with SSO, RBAC, provisioning, audits, and lifecycle automation.",
    bullets: ["AD/AzureAD", "SSO", "RBAC", "Audit"],
    minHeight: 400,
  },
  {
    title: "Collaboration",
    description:
      "Modern collaboration stacks: email, calendars, conferencing, retention policies, and governance.",
    bullets: ["M365/Google", "Email", "Meet", "Policies"],
    minHeight: 400,
  },
  {
    title: "Security",
    description:
      "Defense with AV/EDR, backup policies, phishing awareness training, and incident drill readiness.",
    bullets: ["AV/EDR", "Backups", "Training", "Drills"],
    minHeight: 400,
  },
  {
    title: "Asset Lifecycle",
    description:
      "End‑to‑end asset lifecycle: procurement, imaging, warranty management, and secure decommissioning/wipe.",
    bullets: ["Procure", "Imaging", "Warranty", "Wipe"],
    minHeight: 400,
  },
  {
    title: "Compliance",
    description:
      "Operational compliance for ISO/SOC2 with continuous controls, audits, and enforced policies.",
    bullets: ["ISO", "SOC2", "Policies", "Audits"],
    minHeight: 400,
  },
  {
    title: "Service Catalog",
    description:
      "Self‑service portal with cataloged services, automated workflows, SLAs, and approval chains.",
    bullets: ["Portal", "Workflows", "SLA", "Approvals"],
    minHeight: 400,
  },
];

export default itSupportServicesData;
